import { css as m, LitElement as u, html as s, nothing as p } from "lit";
import { property as c, state as v, customElement as f } from "lit/decorators.js";
import { classMap as b } from "lit/directives/class-map.js";
import { b as w, f as k } from "./styles-scZ6dVz-.js";
import { b as y, a as x } from "./events-CkEPl0SM.js";
var C = Object.defineProperty, $ = Object.getOwnPropertyDescriptor, l = (r, t, o, n) => {
  for (var e = n > 1 ? void 0 : n ? $(t, o) : t, d = r.length - 1, h; d >= 0; d--)
    (h = r[d]) && (e = (n ? h(t, o, e) : h(e)) || e);
  return n && e && C(t, o, e), e;
};
let a = class extends u {
  constructor() {
    super(...arguments), this.severity = "info", this.duration = 5e3, this.closable = !0, this.showProgress = !1, this.exiting = !1, this.progress = 100;
  }
  connectedCallback() {
    super.connectedCallback(), this.duration > 0 && this.startAutoClose();
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.clearTimers();
  }
  startAutoClose() {
    if (this.duration <= 0) return;
    const r = Date.now(), t = () => {
      const o = Date.now() - r;
      this.progress = Math.max(0, 100 - o / this.duration * 100);
    };
    this.showProgress && (this.progressInterval = window.setInterval(t, 50)), this.autoCloseTimer = window.setTimeout(() => {
      this.close();
    }, this.duration);
  }
  clearTimers() {
    this.autoCloseTimer && (clearTimeout(this.autoCloseTimer), this.autoCloseTimer = void 0), this.progressInterval && (clearInterval(this.progressInterval), this.progressInterval = void 0);
  }
  /** Close the toast with animation */
  close() {
    this.clearTimers(), this.exiting = !0, setTimeout(() => {
      y(this, x.CLOSE);
    }, 150);
  }
  handleClose() {
    this.close();
  }
  getIcon() {
    return {
      info: s`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/>
        </svg>
      `,
      success: s`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>
        </svg>
      `,
      warning: s`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><path d="M12 9v4"/><path d="M12 17h.01"/>
        </svg>
      `,
      error: s`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/>
        </svg>
      `
    }[this.severity];
  }
  render() {
    const r = {
      toast: !0,
      [this.severity]: !0,
      exiting: this.exiting
    }, t = s`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
      </svg>
    `;
    return s`
      <div part="toast" class=${b(r)} role="alert" aria-live="polite">
        <span part="icon" class="icon">
          <slot name="icon">${this.getIcon()}</slot>
        </span>

        <div part="content" class="content">
          ${this.toastTitle ? s`<h4 part="title" class="title">${this.toastTitle}</h4>` : p}
          ${this.message ? s`<p part="message" class="message">${this.message}</p>` : p}
          <slot></slot>

          <div part="action" class="actions">
            <slot name="action"></slot>
          </div>
        </div>

        ${this.closable ? s`
              <button
                part="close"
                class="close focus-ring"
                type="button"
                aria-label="Dismiss notification"
                @click=${this.handleClose}
              >
                ${t}
              </button>
            ` : p}

        ${this.showProgress && this.duration > 0 ? s`
              <div class="progress-container">
                <div class="progress-bar" style="width: ${this.progress}%"></div>
              </div>
            ` : p}
      </div>
    `;
  }
};
a.styles = [
  w,
  k,
  m`
      :host {
        display: block;
      }

      .toast {
        display: flex;
        align-items: flex-start;
        gap: var(--r5-space-3);
        padding: var(--r5-space-4);
        background-color: var(--r5-toast-bg, var(--r5-surface));
        border: 1px solid var(--r5-toast-border-color, var(--r5-border));
        border-radius: var(--r5-radius-lg);
        box-shadow: var(--r5-shadow-lg);
        color: var(--r5-text);
        font-family: var(--r5-font-body);
        animation: ark-toast-enter var(--r5-duration-normal) var(--r5-ease-out);
      }

      @keyframes ark-toast-enter {
        from {
          opacity: 0;
          transform: translateY(-0.5rem);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      .toast.exiting {
        animation: ark-toast-exit var(--r5-duration-fast) var(--r5-ease-in) forwards;
      }

      @keyframes ark-toast-exit {
        from {
          opacity: 1;
          transform: translateY(0);
        }
        to {
          opacity: 0;
          transform: translateY(-0.5rem);
        }
      }

      /* Severity variants */
      .info {
        --r5-toast-bg: var(--r5-color-info-50, oklch(0.97 0.01 240));
        --r5-toast-border-color: var(--r5-color-info-200, oklch(0.85 0.05 240));
        --r5-toast-icon-color: var(--r5-color-info-600, oklch(0.55 0.15 240));
      }

      .success {
        --r5-toast-bg: var(--r5-color-success-50, oklch(0.97 0.02 145));
        --r5-toast-border-color: var(--r5-color-success-200, oklch(0.85 0.08 145));
        --r5-toast-icon-color: var(--r5-color-success-600, oklch(0.55 0.18 145));
      }

      .warning {
        --r5-toast-bg: var(--r5-color-warning-50, oklch(0.97 0.03 85));
        --r5-toast-border-color: var(--r5-color-warning-200, oklch(0.85 0.1 85));
        --r5-toast-icon-color: var(--r5-color-warning-600, oklch(0.55 0.18 85));
      }

      .error {
        --r5-toast-bg: var(--r5-color-danger-50, oklch(0.97 0.02 25));
        --r5-toast-border-color: var(--r5-color-danger-200, oklch(0.85 0.08 25));
        --r5-toast-icon-color: var(--r5-color-danger-600, oklch(0.55 0.18 25));
      }

      /* Dark mode adjustments */
      @media (prefers-color-scheme: dark) {
        .info {
          --r5-toast-bg: oklch(0.2 0.02 240);
          --r5-toast-border-color: oklch(0.3 0.04 240);
        }

        .success {
          --r5-toast-bg: oklch(0.2 0.03 145);
          --r5-toast-border-color: oklch(0.3 0.05 145);
        }

        .warning {
          --r5-toast-bg: oklch(0.2 0.04 85);
          --r5-toast-border-color: oklch(0.3 0.06 85);
        }

        .error {
          --r5-toast-bg: oklch(0.2 0.03 25);
          --r5-toast-border-color: oklch(0.3 0.05 25);
        }
      }

      /* Icon */
      .icon {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.25rem;
        height: 1.25rem;
        color: var(--r5-toast-icon-color);
      }

      .icon svg {
        width: 100%;
        height: 100%;
      }

      /* Content */
      .content {
        flex: 1;
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-sm);
        font-weight: var(--r5-font-semibold);
        color: var(--r5-text);
        margin: 0;
        line-height: var(--r5-leading-tight);
      }

      .message {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        margin: var(--r5-space-1) 0 0 0;
        line-height: var(--r5-leading-normal);
      }

      .message:first-child {
        margin-top: 0;
      }

      /* Actions */
      .actions {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        margin-top: var(--r5-space-3);
      }

      .actions:empty {
        display: none;
      }

      /* Close button */
      .close {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1.5rem;
        height: 1.5rem;
        padding: 0;
        border: none;
        background: transparent;
        color: var(--r5-text-muted);
        cursor: pointer;
        border-radius: var(--r5-radius-sm);
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .close:hover {
        background-color: var(--r5-bg-muted);
        color: var(--r5-text);
      }

      .close svg {
        width: 1rem;
        height: 1rem;
      }

      /* Progress bar for auto-dismiss */
      .progress-container {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 3px;
        background-color: rgba(0, 0, 0, 0.1);
        border-radius: 0 0 var(--r5-radius-lg) var(--r5-radius-lg);
        overflow: hidden;
      }

      .progress-bar {
        height: 100%;
        background-color: var(--r5-toast-icon-color);
        transition: width 100ms linear;
      }

      .toast {
        position: relative;
      }

      /* Reduced motion */
      @media (prefers-reduced-motion: reduce) {
        .toast {
          animation: none;
        }

        .toast.exiting {
          animation: none;
          opacity: 0;
        }
      }
    `
];
l([
  c({ type: String, reflect: !0 })
], a.prototype, "severity", 2);
l([
  c({ type: String, attribute: "toast-title" })
], a.prototype, "toastTitle", 2);
l([
  c({ type: String })
], a.prototype, "message", 2);
l([
  c({ type: Number })
], a.prototype, "duration", 2);
l([
  c({ type: Boolean })
], a.prototype, "closable", 2);
l([
  c({ type: Boolean, attribute: "show-progress" })
], a.prototype, "showProgress", 2);
l([
  v()
], a.prototype, "exiting", 2);
l([
  v()
], a.prototype, "progress", 2);
a = l([
  f("ark-toast")
], a);
var T = Object.defineProperty, P = Object.getOwnPropertyDescriptor, g = (r, t, o, n) => {
  for (var e = n > 1 ? void 0 : n ? P(t, o) : t, d = r.length - 1, h; d >= 0; d--)
    (h = r[d]) && (e = (n ? h(t, o, e) : h(e)) || e);
  return n && e && T(t, o, e), e;
};
let i = class extends u {
  constructor() {
    super(...arguments), this.toastId = 0, this.position = "top-right", this.max = 5, this.toasts = [];
  }
  connectedCallback() {
    super.connectedCallback(), i.instance = this;
  }
  disconnectedCallback() {
    super.disconnectedCallback(), i.instance === this && (i.instance = void 0);
  }
  /**
   * Get the singleton instance of the toast container
   */
  static getInstance() {
    return i.instance;
  }
  /**
   * Add a toast notification
   */
  add(r) {
    const t = r.id ?? `toast-${++this.toastId}`, o = {
      id: t,
      severity: r.severity ?? "info",
      title: r.title,
      message: r.message,
      duration: r.duration ?? 5e3,
      closable: r.closable ?? !0,
      showProgress: r.showProgress ?? !1
    };
    return this.toasts.length >= this.max && (this.toasts = this.toasts.slice(1)), this.toasts = [...this.toasts, o], t;
  }
  /**
   * Remove a toast by ID
   */
  dismiss(r) {
    this.toasts = this.toasts.filter((t) => t.id !== r);
  }
  /**
   * Remove all toasts
   */
  clear() {
    this.toasts = [];
  }
  /**
   * Helper methods for common severities
   */
  info(r, t, o) {
    return this.add({ severity: "info", title: r, message: t, ...o });
  }
  success(r, t, o) {
    return this.add({ severity: "success", title: r, message: t, ...o });
  }
  warning(r, t, o) {
    return this.add({ severity: "warning", title: r, message: t, ...o });
  }
  error(r, t, o) {
    return this.add({ severity: "error", title: r, message: t, ...o });
  }
  handleToastClose(r) {
    this.dismiss(r);
  }
  render() {
    const r = {
      container: !0,
      [this.position]: !0
    };
    return s`
      <div part="container" class=${b(r)}>
        ${this.toasts.map(
      (t) => s`
            <ark-toast
              severity=${t.severity ?? "info"}
              toast-title=${t.title ?? ""}
              message=${t.message ?? ""}
              duration=${t.duration ?? 5e3}
              ?closable=${t.closable}
              ?show-progress=${t.showProgress}
              @ark-close=${() => this.handleToastClose(t.id)}
            ></ark-toast>
          `
    )}
      </div>
    `;
  }
};
i.styles = [
  w,
  m`
      :host {
        display: contents;
      }

      .container {
        position: fixed;
        z-index: var(--r5-z-toast, 1100);
        display: flex;
        flex-direction: column;
        gap: var(--r5-toast-container-gap, var(--r5-space-3));
        padding: var(--r5-toast-container-padding, var(--r5-space-4));
        pointer-events: none;
        max-height: 100vh;
        overflow: hidden;
      }

      .container > * {
        pointer-events: auto;
      }

      /* Horizontal positions */
      .top-left,
      .bottom-left {
        left: 0;
        align-items: flex-start;
      }

      .top-center,
      .bottom-center {
        left: 50%;
        transform: translateX(-50%);
        align-items: center;
      }

      .top-right,
      .bottom-right {
        right: 0;
        align-items: flex-end;
      }

      /* Vertical positions */
      .top-left,
      .top-center,
      .top-right {
        top: 0;
      }

      .bottom-left,
      .bottom-center,
      .bottom-right {
        bottom: 0;
        flex-direction: column-reverse;
      }

      /* Toast width */
      ark-toast {
        width: var(--r5-toast-width, 360px);
        max-width: calc(100vw - var(--r5-toast-container-padding, var(--r5-space-4)) * 2);
      }
    `
];
g([
  c({ type: String, reflect: !0 })
], i.prototype, "position", 2);
g([
  c({ type: Number })
], i.prototype, "max", 2);
g([
  v()
], i.prototype, "toasts", 2);
i = g([
  f("ark-toast-container")
], i);
export {
  a as A,
  i as a
};
//# sourceMappingURL=ark-toast-container-BKZDNxmK.js.map
